import { useState, useEffect } from 'react';
import { docsRegistry } from '../config/docs.registry';

// Load raw text
const mdFiles = import.meta.glob('../content/*.md', { query: '?raw', import: 'default' });

export function useDocs(docId?: string) {
  const [content, setContent] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!docId) {
      setContent(null);
      return;
    }

    const loadContent = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const filePath = `../content/${docId}.md`;
        const loadMarkdown = mdFiles[filePath];
        
        if (!loadMarkdown) {
          throw new Error('Không tìm thấy tài liệu');
        }
        
        const result = await loadMarkdown();
        setContent(String(result));
      } catch (err: any) {
        setError(err);
        setContent(null);
      } finally {
        setIsLoading(false);
      }
    };

    loadContent();
  }, [docId]);

  return {
    registry: docsRegistry,
    content,
    isLoading,
    error,
  };
}
